(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("google-photorealistic-3d-tiles", [], factory);
	else if(typeof exports === 'object')
		exports["google-photorealistic-3d-tiles"] = factory();
	else
		root["google-photorealistic-3d-tiles"] = factory();
})(self, function() {
return 